import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import TimeInput from '../../../TimeInput';
import Icon from '../../../Icon';
import { utils } from 'gipsy-misc';

import Field, { Close } from '../../components/Field';

var EstimatedTime = function (_PureComponent) {
  _inherits(EstimatedTime, _PureComponent);

  function EstimatedTime() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, EstimatedTime);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = EstimatedTime.__proto__ || Object.getPrototypeOf(EstimatedTime)).call.apply(_ref, [this].concat(args))), _this), _this.state = { hover: false }, _this.deactivateField = function (e) {
      var id = _this.props.id;

      _this.props.deactivateField && _this.props.deactivateField(e, id);
      _this.props.onChange({ paramName: id, value: 0 });
    }, _this.onChange = function (_ref2) {
      var paramName = _ref2.paramName,
          value = _ref2.value;

      var data = {
        paramName: paramName,
        value: utils.datetime.getNanosecondsFromHourAndMinute({
          hour: value.hour,
          minute: value.minute
        })
      };

      _this.props.onChange(data);
    }, _this.handleMouseEnter = function () {
      _this.setState({ hover: true });
    }, _this.handleMouseLeave = function () {
      _this.setState({ hover: false });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(EstimatedTime, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          noPadding = _props.noPadding,
          backgroundHover = _props.backgroundHover,
          showClose = _props.showClose,
          mode = _props.mode,
          id = _props.id,
          label = _props.label,
          isActive = _props.isActive,
          isOpen = _props.isOpen,
          toggleField = _props.toggleField,
          value = _props.value;
      var hover = this.state.hover;

      var _utils$datetime$getHo = utils.datetime.getHourAndMinuteFromNanoseconds(value),
          hour = _utils$datetime$getHo.hour,
          minute = _utils$datetime$getHo.minute;

      return React.createElement(
        Field,
        {
          noPadding: noPadding,
          backgroundHover: backgroundHover,
          className: 'time-field' + (isActive ? ' active' : '') + (isOpen ? ' open' : ''),
          onMouseEnter: this.handleMouseEnter,
          onMouseLeave: this.handleMouseLeave },
        React.createElement(
          'div',
          { onClick: function onClick(e) {
              return toggleField(e, id);
            }, className: 'row click-field gp-layout gp-row gp-space-between' },
          React.createElement(
            'div',
            { className: 'field-label' },
            React.createElement(Icon, { className: 'label-icon', icon: 'Stopwatch' }),
            React.createElement(
              'span',
              { className: 'label-text' },
              label
            )
          ),
          mode === 'preview' ? React.createElement(
            'div',
            { className: 'value' },
            value
          ) : React.createElement(
            'div',
            { className: 'value' },
            isOpen || hover ? React.createElement(
              'div',
              { className: 'estimated-time-input' },
              React.createElement(TimeInput, {
                showIncrementButtons: true,
                showPeriod: false,
                paramName: 'estimatedTime',
                hour: hour,
                minute: minute,
                onChange: this.onChange
              })
            ) : React.createElement(
              'span',
              null,
              utils.datetime.beautifyDuration(value, true)
            )
          )
        ),
        showClose && React.createElement(Close, { onClick: this.deactivateField })
      );
    }
  }]);

  return EstimatedTime;
}(PureComponent);

EstimatedTime.propTypes = {
  mode: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  id: PropTypes.string,
  isActive: PropTypes.bool.isRequired,
  isOpen: PropTypes.bool.isRequired,
  deactivateField: PropTypes.func,
  toggleField: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.any,
  noPadding: PropTypes.bool,
  backgroundHover: PropTypes.string,
  showClose: PropTypes.bool
};
EstimatedTime.defaultProps = {
  showClose: true
};


export default EstimatedTime;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../gipsy-ui/lib/TaskPanel/fields/EstimatedTime/index.js
// module id = 494
// module chunks = 0